export * from './points-purchase.page'
